<script setup lang="ts">
  import { computed } from 'vue'
  import type { TDropdownOption } from '@/types/dropdown'

  const props = defineProps<{
    option: TDropdownOption
    active?: boolean
    color?: 'blue' | 'purple'
  }>()

  defineEmits<{
    click: []
  }>()

  const activeClass = computed(() =>
    props.color === 'purple'
      ? 'border-purple-50 bg-purple-50/5 text-purple-50'
      : 'border-blue-50 bg-blue-50/5 text-blue-50',
  )

  const iconClass = computed(() => (props.color === 'purple' ? 'text-purple-50' : 'text-blue-50'))
</script>

<template>
  <button
    class="group inline-flex items-center gap-1.5 pl-3.5 pr-4 py-1.5 border rounded-full text-xs select-none cursor-pointer transition-all"
    :class="active ? activeClass : 'border-black-90 bg-white text-black-20 hover:shadow-lg'"
    @click="$emit('click')"
  >
    <des-icon
      v-if="option.icon"
      :icon="option.icon"
      class="w-icon h-icon"
      :class="active ? 'group-hover:hidden' : iconClass"
    />
    <des-icon
      v-if="option.icon && active"
      icon="fa-light fa-xmark"
      class="w-icon h-icon hidden group-hover:inline-block"
    />
    {{ option.label }}
  </button>
</template>
